/**
 * Provides browser data from a given User-Agent string
 */

import MobileDetect from 'mobile-detect';

var md = new MobileDetect(window.navigator.userAgent);

var isMobile = Boolean(md.mobile());
var isTablet = Boolean(md.tablet());
var isPhone = Boolean(md.phone());

// detect browser type
var browserType = 'desktop';
if (isPhone) {
    browserType = 'phone';
} else if (isTablet) {
    browserType = 'tablet';
}

export default {
    isMobile: isMobile,
    isPhone: isPhone,
    isTablet: isTablet,
    browserType: browserType
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-featuredetection-js/browserdetect/BrowserDetectData.js
// module id = 110
// module chunks = 0